// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"b7c0105a","147":"d8b32925","362":"03fb3f19","574":"db612299","669":"e3979645","807":"08a1f1b4","818":"ec77f73f","899":"e41afa5b","900":"274ad7ba","996":"3c31774c"}[chunkId] + ".chunk.js";
};